/* Amada: zoom das fotos da página de produto (15/09/2026, pedido do Mendes).
   Abre pela lupa ou tocando na foto. Pinça e toque duplo no celular; clique e roda do mouse no computador;
   arrastar move a foto ampliada; setas, deslize e teclado trocam a foto; ao fechar, a galeria vai para a mesma foto.
   Independente do amada-pdp-v2.js: só lê o DOM da galeria e usa as miniaturas para sincronizar. */
(function () {
  if (window.__amadaZoom) return;
  window.__amadaZoom = true;

  var MAX = 4, PASSO = 2.5;

  function iniciar(galeria) {
    var slides = [].slice.call(galeria.querySelectorAll('[data-gallery-slide]'));
    var fotos = [];
    slides.forEach(function (s) {
      var img = s.querySelector('img[data-zoom-src]');
      if (img) fotos.push({ slide: Number(s.getAttribute('data-gallery-slide')), src: img.getAttribute('data-zoom-src'), baixa: img, alt: img.getAttribute('alt') || '' });
    });
    if (!fotos.length) return;
    var titulo = galeria.getAttribute('data-zoom-title') || '';

    var d = document.createElement('dialog');
    d.id = 'amada-zoom';
    d.className = 'amada-zoom';
    d.setAttribute('aria-label', 'Image zoom');
    d.innerHTML =
      '<div class="dialog-header"><h2>The details, up close</h2>' +
        '<button type="button" class="dialog-close" data-z="close" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"/></svg></button>' +
      '</div>' +
      '<div class="amada-zoom__stage"><img class="amada-zoom__img" alt="" draggable="false"></div>';
    document.body.appendChild(d);

    var palco = d.querySelector('.amada-zoom__stage');
    var img = d.querySelector('.amada-zoom__img');

    var atual = 0, s = 1, tx = 0, ty = 0, bw = 0, bh = 0, ox = 0, oy = 0, W = 0, H = 0;
    var acionador = null;

    function medir() {
      var r = palco.getBoundingClientRect();
      W = r.width; H = r.height;
      var nw = img.naturalWidth || 1, nh = img.naturalHeight || 1;
      var k = Math.min(W / nw, H / nh);
      bw = nw * k; bh = nh * k;
      ox = (W - bw) / 2; oy = (H - bh) / 2;
      img.style.width = bw + 'px';
      img.style.height = bh + 'px';
    }
    function limitar() {
      if (s * bw <= W) tx = (W - s * bw) / 2 - ox; else tx = Math.min(-ox, Math.max(W - s * bw - ox, tx));
      if (s * bh <= H) ty = (H - s * bh) / 2 - oy; else ty = Math.min(-oy, Math.max(H - s * bh - oy, ty));
    }
    function aplicar(animar) {
      limitar();
      img.style.transition = animar ? 'transform .22s ease' : 'none';
      img.style.transform = 'translate(' + (ox + tx) + 'px,' + (oy + ty) + 'px) scale(' + s + ')';
      d.classList.toggle('is-zoomed', s > 1.01);
    }
    function zoomEm(novo, px, py, animar) {
      novo = Math.max(1, Math.min(MAX, novo));
      var x = (px - ox - tx) / s, y = (py - oy - ty) / s;
      s = novo;
      tx = px - ox - x * s; ty = py - oy - y * s;
      aplicar(animar);
    }
    function reset() { s = 1; tx = 0; ty = 0; }

    function mostrar(i) {
      atual = (i + fotos.length) % fotos.length;
      var f = fotos[atual];
      reset();
      img.alt = f.alt;
      d.classList.add('is-loading');
      var baixa = f.baixa.currentSrc || f.baixa.src;
      var alta = new Image();
      img.src = baixa;
      var pronto = function () { medir(); aplicar(false); };
      if (img.complete) pronto(); else img.onload = pronto;
      alta.onload = function () {
        if (fotos[atual] !== f) return;
        img.onload = function () { medir(); aplicar(false); d.classList.remove('is-loading'); };
        img.src = f.src;
      };
      alta.src = f.src;
      [fotos[(atual + 1) % fotos.length], fotos[(atual - 1 + fotos.length) % fotos.length]].forEach(function (v) { if (v) { var p = new Image(); p.src = v.src; } });
    }

    function abrir(indiceSlide, botao) {
      acionador = botao || null;
      var i = 0;
      fotos.forEach(function (f, n) { if (f.slide === indiceSlide) i = n; });
      document.documentElement.classList.add('amada-zoom-open');
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      mostrar(i);
      d.querySelector('[data-z="close"]').focus({ preventScroll: true });
    }
    function fechar() {
      if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open');
      document.documentElement.classList.remove('amada-zoom-open');
      var thumb = galeria.querySelector('[data-gallery-thumb="' + fotos[atual].slide + '"]');
      if (thumb) thumb.click();
      else {
        var trilha = galeria.querySelector('[data-gallery-track]');
        if (trilha) trilha.scrollTo({ left: fotos[atual].slide * trilha.clientWidth });
      }
      if (acionador) acionador.focus({ preventScroll: true });
    }

    /* abrir: lupa e toque/clique na foto (ignora quando foi arrasto da galeria) */
    var lupa = galeria.querySelector('[data-zoom-open]');
    var ativo = function () {
      var a = galeria.querySelector('.amada-gallery__slide.is-active');
      return a ? Number(a.getAttribute('data-gallery-slide')) : 0;
    };
    if (lupa) lupa.addEventListener('click', function (e) { e.preventDefault(); abrir(ativo(), lupa); });
    var trilha = galeria.querySelector('[data-gallery-track]');
    var ini = null;
    if (trilha) {
      trilha.addEventListener('pointerdown', function (e) { ini = { x: e.clientX, y: e.clientY }; }, { passive: true });
      trilha.addEventListener('click', function (e) {
        var alvo = e.target.closest('img[data-zoom-src]');
        if (!alvo || !ini) return;
        if (Math.abs(e.clientX - ini.x) > 6 || Math.abs(e.clientY - ini.y) > 6 || trilha.classList.contains('is-dragging')) return;
        var slide = alvo.closest('[data-gallery-slide]');
        abrir(Number(slide.getAttribute('data-gallery-slide')), lupa);
      });
    }

    /* botões */
    d.addEventListener('click', function (e) {
      var b = e.target.closest('[data-z]');
      if (!b) return;
      var acao = b.getAttribute('data-z');
      if (acao === 'close') fechar();
      else if (acao === 'next') mostrar(atual + 1);
      else if (acao === 'prev') mostrar(atual - 1);
      else if (acao === 'in') zoomEm(s * 1.6, W / 2, H / 2, true);
      else if (acao === 'out') zoomEm(s / 1.6, W / 2, H / 2, true);
    });
    d.addEventListener('cancel', function (e) { e.preventDefault(); fechar(); });
    /* clique fora da janela fecha (igual ao mockup) */
    d.addEventListener('click', function (e) {
      if (e.target !== d) return;
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) fechar();
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { mostrar(atual + 1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { mostrar(atual - 1); e.preventDefault(); }
      else if (e.key === '+' || e.key === '=') { zoomEm(s * 1.6, W / 2, H / 2, true); e.preventDefault(); }
      else if (e.key === '-') { zoomEm(s / 1.6, W / 2, H / 2, true); e.preventDefault(); }
    });

    /* gestos no palco. Toque: eventos de toque nativos (pinça confiável no iOS e Android).
       Mouse e caneta: eventos de ponteiro. */
    var gesto = null, ultimoToque = 0, ultimoXY = null;
    function local(pt) { var r = palco.getBoundingClientRect(); return { x: pt.clientX - r.left, y: pt.clientY - r.top }; }
    function sobreBotao(alvo) { return alvo && alvo.closest && alvo.closest('[data-z]'); }

    /* mouse */
    palco.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || sobreBotao(e.target)) return;
      palco.setPointerCapture(e.pointerId);
      gesto = { tipo: 'mouse', x0: e.clientX, y0: e.clientY, tx0: tx, ty0: ty, moveu: false, id: e.pointerId };
    });
    palco.addEventListener('pointermove', function (e) {
      if (!gesto || gesto.tipo !== 'mouse' || e.pointerId !== gesto.id) return;
      var dx = e.clientX - gesto.x0, dy = e.clientY - gesto.y0;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) gesto.moveu = true;
      if (s > 1.01 && gesto.moveu) { tx = gesto.tx0 + dx; ty = gesto.ty0 + dy; aplicar(false); palco.classList.add('is-grabbing'); }
    });
    function soltarMouse(e) {
      if (!gesto || gesto.tipo !== 'mouse' || e.pointerId !== gesto.id) return;
      palco.classList.remove('is-grabbing');
      var dx = e.clientX - gesto.x0, dy = e.clientY - gesto.y0;
      if (gesto.moveu) {
        if (s <= 1.01 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) mostrar(atual + (dx < 0 ? 1 : -1));
      } else if (e.type === 'pointerup') {
        var pos = local(e);
        zoomEm(s > 1.01 ? 1 : PASSO, pos.x, pos.y, true);
      }
      gesto = null;
    }
    palco.addEventListener('pointerup', soltarMouse);
    palco.addEventListener('pointercancel', soltarMouse);

    /* toque */
    function distancia(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
    function meio(t) { return local({ clientX: (t[0].clientX + t[1].clientX) / 2, clientY: (t[0].clientY + t[1].clientY) / 2 }); }
    palco.addEventListener('touchstart', function (e) {
      if (sobreBotao(e.target)) return;
      e.preventDefault();
      if (e.touches.length >= 2) {
        gesto = { tipo: 'pinca', dist: distancia(e.touches) || 1, s0: s };
      } else if (e.touches.length === 1) {
        var t = e.touches[0];
        gesto = { tipo: 'dedo', x0: t.clientX, y0: t.clientY, tx0: tx, ty0: ty, moveu: false };
      }
    }, { passive: false });
    palco.addEventListener('touchmove', function (e) {
      if (!gesto) return;
      e.preventDefault();
      if (gesto.tipo === 'pinca' && e.touches.length >= 2) {
        var m = meio(e.touches);
        zoomEm(gesto.s0 * distancia(e.touches) / gesto.dist, m.x, m.y, false);
      } else if (gesto.tipo === 'dedo' && e.touches.length === 1) {
        var t = e.touches[0], dx = t.clientX - gesto.x0, dy = t.clientY - gesto.y0;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) gesto.moveu = true;
        if (s > 1.01 && gesto.moveu) { tx = gesto.tx0 + dx; ty = gesto.ty0 + dy; aplicar(false); }
      }
    }, { passive: false });
    function soltarToque(e) {
      if (!gesto) return;
      if (gesto.tipo === 'pinca') {
        if (e.touches.length === 1) {
          var resto = e.touches[0];
          gesto = { tipo: 'dedo', x0: resto.clientX, y0: resto.clientY, tx0: tx, ty0: ty, moveu: true };
        } else if (e.touches.length === 0) { gesto = null; }
        return;
      }
      if (e.touches.length > 0) return;
      var t = e.changedTouches[0], dx = t.clientX - gesto.x0, dy = t.clientY - gesto.y0;
      if (gesto.moveu) {
        if (s <= 1.01 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) mostrar(atual + (dx < 0 ? 1 : -1));
      } else if (e.type === 'touchend') {
        /* Um toque simples ja amplia, igual ao clique no computador (linha do soltarMouse).
           O segundo toque em ate 320ms e ignorado, senao o toque duplo ampliaria e voltaria na mesma hora.
           Medido nas gravacoes do PostHog em 25/09/2026: 20 toques simples morriam aqui dentro do zoom,
           com clique repetido em 2 sessoes. No celular a pessoa tocava na foto e nada acontecia. */
        var pos = local(t), agora = Date.now();
        if (agora - ultimoToque < 320 && ultimoXY && Math.hypot(pos.x - ultimoXY.x, pos.y - ultimoXY.y) < 30) {
          ultimoToque = 0;
        } else {
          zoomEm(s > 1.01 ? 1 : PASSO, pos.x, pos.y, true);
          ultimoToque = agora; ultimoXY = pos;
        }
      }
      gesto = null;
    }
    palco.addEventListener('touchend', soltarToque);
    palco.addEventListener('touchcancel', soltarToque);
    palco.addEventListener('wheel', function (e) {
      e.preventDefault();
      var pos = local(e);
      zoomEm(s * Math.exp(-e.deltaY * 0.0022), pos.x, pos.y, false);
    }, { passive: false });
    window.addEventListener('resize', function () { if (d.open) { medir(); aplicar(false); } });
  }

  function comecar() { document.querySelectorAll('[data-gallery]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', comecar); else comecar();
})();
